import { Controller, Get } from '@nestjs/common'
import { ApiTags } from '@nestjs/swagger'
import { HealthCheck, HealthCheckService, TypeOrmHealthIndicator } from '@nestjs/terminus'
import { AppHealthIndicator, RedisHealthIndicator } from './indicators'

@Controller('health')
@ApiTags('default')
export class HealthController {
	constructor(
		private readonly _healthService: HealthCheckService,
		private readonly _app: AppHealthIndicator,
		private readonly _typeorm: TypeOrmHealthIndicator,
		private readonly _redis: RedisHealthIndicator,
	) {}

	@Get()
	@HealthCheck()
	async check() {
		return this._healthService.check([
			() => this._app.pingCheck('app'),
			() => this._typeorm.pingCheck('database'),
			() => this._redis.pingCheck('cache'),
		])
	}
}
